import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Input,
  Card,
  Select,
  Typography,
  Spin,
  message,
  PageHeader,
  Modal,
  Button,
  Table,
  Row,
  Col,
  Divider,
} from "antd";
import { adminServiceAction } from "../../_actions/admin.service";
import { gangDetectionAction } from "../../_actions/gang.detection.actions";
import { ViewFormModel } from "../ProfessionalForm/ViewForm/ViewFormModel";
import { connect } from "react-redux";
import { professionalAction } from "../../_actions";
import { LanguageContext } from "../../context/LanguageContext";
import {
  BarChartOutlined,
  BulbOutlined,
  EnvironmentOutlined,
  SafetyOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { ViewGunaDetails } from "../viewGunaDetails/viewGunaDetails";
import cytoscape from "cytoscape";
import domtoimage from "dom-to-image-more";

const { Search } = Input;
const { Option } = Select;
const { Title, Text } = Typography;

const GraphView = (props) => {
  const { match, dispatch, professionals } = props;
  const { t } = useContext(LanguageContext);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [selectedGunha, setSelectedGunha] = useState(null);
  const [loader, setLoader] = useState(false);
  const [viewCrimeProfile, setViewCrimeProfile] = useState(false);
  const [gunaLoading, setGunaLoading] = useState(false);
  const [gunaView, setgunaView] = useState(false);
  const [isIsolated, setIsIsolated] = useState(false);
  const [gangDetails, setGangDetails] = useState();
  const [masterId, setMasterId] = useState(null);
  const [memeber, setMember] = useState([]);
  const [found, setFound] = useState(false);
  const cyRef = useRef(null); // Graph container
  const cyInstance = useRef(null); // Cytoscape instance

  /* ------------------- ZOOM CONTROLS ------------------- */

  const zoomIn = () => {
    const cy = cyInstance.current;
    if (!cy) return;
    cy.zoom({
      level: cy.zoom() * 1.2,
      renderedPosition: { x: cy.width() / 2, y: cy.height() / 2 },
    });
  };

  const zoomOut = () => {
    const cy = cyInstance.current;
    if (!cy) return;
    cy.zoom({
      level: cy.zoom() * 0.8,
      renderedPosition: { x: cy.width() / 2, y: cy.height() / 2 },
    });
  };

  const resetZoom = () => {
    cyInstance.current?.fit();
  };

  const handleSearch = async (value) => {
    if (!value) {
      message.error("Please enter ID");
      return;
    }
    setMasterId(value);
    try {
      setLoading(true);
      let temp = {
        id: value,
        userid: props.user.id,
      };

      adminServiceAction.getCriminalDetails(temp).then((res) => {
        if (res.basicInfo.length > 0) {
          setData(res);
          setSelectedGunha(res?.gunhaInformation);
          getGangDetails(res?.gunhaInformation);
        } else {
          setFound(true);
        }
      });
    } catch (err) {
      console.error(err);
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleCrimeProfile = (id) => {
    setViewCrimeProfile(true);
    dispatch(professionalAction.getCriminalsViewsById(id));
  };

  const closeCrimeProfile = () => {
    setViewCrimeProfile(false);
  };

  const handleGunaView = (id) => {
    setgunaView(true);
    setGunaLoading(true);
    dispatch(professionalAction.getCriminalsViewsById(id));
  };
  const closeGunaView = () => {
    setgunaView(false);
  };

  useEffect(() => {
    dispatch(professionalAction.getAllMaster());
    props.dispatch(professionalAction.getCity());
    props.dispatch(professionalAction.getDharm());
    props.dispatch(professionalAction.getKalam());
    props.dispatch(professionalAction.getKayda());
    props.dispatch(professionalAction.getCrimeType());
    props.dispatch(professionalAction.getCrimeTitle());
    props.dispatch(professionalAction.getStatus());
  }, []);

  const memberColumns = [
    {
      title: t("sr.no"),
      render: (_, __, index) => index + 1,
      width: 80,
    },
    {
      title: "CMIS ID",
      dataIndex: "masterId",
      sorter: (a, b) => a.masterId - b.masterId,
    },
    {
      title: t("name_of_the_accused"),
      dataIndex: "name",
      render: (text, record) => (
        <Button
          type="link"
          onClick={() => {
            handleCrimeProfile(record.masterId);
          }}
        >
          {text}
        </Button>
      ),
    },
    {
      title: t("accused_police_station"),
      dataIndex: "districtName",
      sorter: (a, b) => a.districtName - b.districtName,
    },
    {
      title: t("total_crimes"),
      dataIndex: "totalCrimes",
      sorter: (a, b) => a.totalCrimes - b.totalCrimes,
      render: (text, record) => (
        <Button
          type="primary"
          shape="circle"
          size="small"
          style={{
            width: 36,
            height: 36,
            fontWeight: 600,
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
          }}
          onClick={() => {
            handleGunaView(record.masterId);
          }}
        >
          {text}
        </Button>
      ),
    },
    {
      title: "FIR",
      dataIndex: "fir",
      render: (text, record) => (
        <>
          {" "}
          {record.firFormatted}({record.gunadistrictName})
        </>
      ),
    },
    {
      title: t("title"),
      dataIndex: "title",
      sorter: (a, b) => a.title - b.title,
    },
  ];

  const [gang, setGang] = useState();
  useEffect(() => {
    // If gunaLoading is true and we have received new data, stop loading
    if (
      gunaLoading &&
      props.professionals?.criminalViewList &&
      Object.keys(props.professionals.criminalViewList).length > 0
    ) {
      setGunaLoading(false);
    }
  }, [props.professionals?.criminalViewList]);

  const getGangDetails = (fir) => {
    setLoader(true); // show loader immediately

    gangDetectionAction
      .getGangDetails({ fir: fir })
      .then((res) => {
        const data = res?.data;
        if (data) {
          console.log("data=>", data);
          const uniqueMembers = Array.from(
            new Map(
              data.members.map((item) => [item.masterId, item]), // ✅ key + value
            ).values(),
          );
          setGangDetails({
            ...data,
            members: uniqueMembers,
          });
          setMember(uniqueMembers);
          const graph = data.graph;
          if (!graph || !graph.nodes || graph.nodes.length === 0) {
            setIsIsolated(true);
            setLoader(false);
            return;
          }

          setGang(graph);
          GangMemberList(uniqueMembers);
        } else {
          setFound(true);
        }
      })
      .catch((err) => {
        console.error("Error fetching gang details:", err);
        setIsIsolated(true);
      })
      .finally(() => {
        setLoader(false); // stop loader after data or error
      });
  };

  const GangMemberList = (uniqueMembers) => {
    setLoader(true);
    let temp = {
      memberList: uniqueMembers,
    };
    gangDetectionAction.GangMemberList(temp).then((res) => {
      console.log("res", res);
      setMember(res.data);
    });
    setLoader(false);
  };

  useEffect(() => {
    if (loader) return;
    if (!gang || isIsolated || !cyRef.current) return;

    const cy = cytoscape({
      container: cyRef.current,
      elements: [...gang.nodes, ...gang.edges],

      style: [
        {
          selector: "node",
          style: {
            label: "data(label)",
            "background-color": "#ffb3b3",
            "border-color": "#e60000",
            "border-width": 2,
            color: "#000",
            "font-weight": "bold",
            "text-valign": "center",
            "text-halign": "center",
            shape: "round-rectangle",
            width: 140,
            height: 40,
            "text-wrap": "wrap",
            "text-max-width": 120,
          },
        },
        {
          selector: "edge",
          style: {
            label: "data(label)",
            "curve-style": "bezier",
            "target-arrow-shape": "triangle",
            "line-color": "#888",
            "target-arrow-color": "#888",
          },
        },
      ],

      layout: {
        name: "dagre",
        rankDir: "LR",
        padding: 50,
        nodeSep: 80,
        edgeSep: 40,
        rankSep: 100,
        animate: true,
      },
    });

    // 🔥 Hover event (console only)
    // cy.on("mouseover", "node", (event) => {
    //   const node = event.target;
    //   const data = node.data();

    //   console.log("Hovered Node Data:", data);
    //   console.log("Master ID:", data.masterId);
    // });

    // cy.on("mouseover", "node", (event) => {
    //   const data = event.target.data();
    //   console.log("MasterId:", data.masterId || data.id);
    // });
    // cy.on("mouseover", "edge", (event) => {
    //   const data = event.target.data();
    //   console.log("Criminal IDs:", data.criminals);
    // });
    // cy.on("mouseover", "node", (event) => {
    //   const data = event.target.data();
    //   const title = data.title || data.label;

    //   cy.container().setAttribute("title", title);
    // });

    // // Edge hover
    // cy.on("mouseover", "edge", (event) => {
    //   const data = event.target.data();
    //   const title = data.label;

    //   cy.container().setAttribute("title", title);
    // });

    // // Remove title on mouse out
    // cy.on("mouseout", () => {
    //   cy.container().removeAttribute("title");
    // });

    cyInstance.current = cy;

    setTimeout(() => cy.fit(), 200);

    return () => {
      cy.destroy();
      cyInstance.current = null;
    };
  }, [gang, isIsolated, loader]);

  const zoomBtnStyle = {
    width: 36,
    height: 36,
    borderRadius: 6,
    border: "1px solid #d9d9d9",
    background: "#fff",
    fontSize: 18,
    fontWeight: "bold",
    cursor: "pointer",
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
  };

  const downloadGraph = () => {
    const node = cyRef.current;

    if (!node) return;

    domtoimage
      .toPng(node)
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "graph.png";
        link.href = dataUrl;
        link.click();
      })
      .catch((error) => {
        console.error("Download failed:", error);
      });
  };
  const messages = [
    "AI scanning accused database...",
    "Linking accused records...",
    "Analyzing criminal patterns...",
    "Detecting gang network...",
  ];

  const [textIndex, setTextIndex] = useState(0);
  const [ids, setIds] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  // 🔹 Text animation
  useEffect(() => {
    if (!loader) return;

    const interval = setInterval(() => {
      setTextIndex((prev) => (prev + 1) % messages.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [loader]);

  // 🔹 Random IDs
  useEffect(() => {
    if (!loader) return;

    const interval = setInterval(() => {
      const randomID = () => Math.floor(170000 + Math.random() * 20000);

      setIds(`Linked MasterID: ${randomID()} | ${randomID()}`);
    }, 800);

    return () => clearInterval(interval);
  }, [loader]);

  // 🔹 Alert trigger
  useEffect(() => {
    if (!loader) return;

    const interval = setInterval(() => {
      if (Math.random() > 0.7) {
        setShowAlert(true);
        setTimeout(() => setShowAlert(false), 1500);
      }
    }, 4000);

    return () => clearInterval(interval);
  }, [loader]);

  const [activeNode, setActiveNode] = useState(null);

  useEffect(() => {
    if (!loader) return;

    const interval = setInterval(() => {
      const rand = Math.floor(Math.random() * 6);
      setActiveNode(rand);
    }, 600);

    return () => clearInterval(interval);
  }, [loader]);
  const makeFirData = (list = []) =>
    list.flatMap((obj, index) =>
      Object.entries(obj).map(([name, count]) => ({
        key: `${index}-${name}`,
        name,
        count,
      })),
    );
  const firColumns = [
    {
      title: t("sr.no"),
      render: (_, __, index) => index + 1,
      width: 80,
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: t("आरोपी"),
      dataIndex: "count",
    },
  ];

  const yearCountData =
    gangDetails?.analysis?.year_count?.flatMap((obj, index) =>
      Object.entries(obj).map(([year, count]) => ({
        key: `${index}-${year}`,
        year,
        count,
      })),
    ) || [];

  const yearColumns = [
    {
      title: t("sr.no"),
      render: (_, __, index) => index + 1,
      width: 80,
    },
    {
      title: t("year"),
      dataIndex: "year",
    },
    {
      title: t("total_crimes"),
      dataIndex: "count",
    },
  ];

  /* =========================
       4. DYNAMIC POLICE ACTION TABLE
       ========================= */
  const tableData = gangDetails?.analysis?.table || [];
  const handleCommonCriminalClick = (id, record) => {
    console.log("Row data:", record, id);
    handleCrimeProfile(id);
    // example:
    // dispatch(getCommonCriminals(record.source_fir, record.target_fir))
  };

  const dynamicColumns =
    tableData.length > 0
      ? [
          {
            title: t("sr.no"),
            render: (_, __, index) => index + 1,
            width: 80,
          },
          ...Object.keys(tableData[0]).map((key) => ({
            title: key.replace(/_/g, " ").toUpperCase(),
            dataIndex: key,
            key,
            ellipsis: true,
            render:
              key === "common criminals"
                ? (value, record) => {
                    if (!value) return "-";

                    const ids = value
                      .toString()
                      .split(",")
                      .map((id) => id.trim());

                    return (
                      <>
                        {ids.map((id) => (
                          <Button
                            key={id}
                            type="link"
                            onClick={() =>
                              handleCommonCriminalClick(id, record)
                            }
                          >
                            {id}
                          </Button>
                        ))}
                      </>
                    );
                  }
                : undefined,
          })),
        ]
      : [];

  return (
    <>
      <div className="col-md-6 col-md-offset-3">
        <div className="site-page-header-ghost-wrapper">
          <PageHeader
            className="site-page-header"
            ghost={false}
            onBack={false}
            title={t("find_partner")}
          >
            {/* 🔍 Search */}
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <p style={{ margin: 0 }}>आरोपीचा CMIS ID:</p>

              <Search
                placeholder={t("guna_id")}
                enterButton="Search"
                size="large"
                onSearch={handleSearch}
                style={{ width: "300px" }}
              />
            </div>
            <React.Suspense fallback={<div>Loading...</div>}>
              {/* ⏳ Loader */}

              {data && (
                <Card
                  style={{
                    border: "1px solid #d9d9d9",
                    borderRadius: 6,
                    marginTop: "10px",
                  }}
                >
                  {data && (
                    <Row
                      style={{
                        padding: "10px 0",
                      }}
                    >
                      {/* Name */}
                      <Col span={6}>
                        <Text strong>{t("name_of_the_accused")}: </Text>
                        <Text>{data.basicInfo?.[0]?.name || "N/A"}</Text>
                      </Col>

                      {/* Crime Count */}
                      <Col span={6}>
                        <Text strong>{t("total_crimes")}: </Text>
                        <Text>
                          {" "}
                          <Button
                            type="primary"
                            shape="circle"
                            size="small"
                            style={{
                              width: 36,
                              height: 36,
                              fontWeight: 600,
                              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                            }}
                            onClick={() => {
                              handleGunaView(masterId);
                            }}
                          >
                            {data.crimeCount || "0"}
                          </Button>
                        </Text>
                      </Col>
                    </Row>
                  )}
                </Card>
              )}
            </React.Suspense>
            {loader === true ? (
              <div className="loader-wrapper">
                <div className="network">
                  <svg width="260" height="260" className="svg1">
                    <line x1="130" y1="130" x2="130" y2="30" />
                    <line x1="130" y1="130" x2="230" y2="130" />
                    <line x1="130" y1="130" x2="130" y2="230" />
                    <line x1="130" y1="130" x2="30" y2="130" />
                    <line x1="130" y1="130" x2="200" y2="60" />
                    <line x1="130" y1="130" x2="60" y2="200" />
                  </svg>

                  <div className="node1 center"></div>

                  {[...Array(6)].map((_, i) => (
                    <div
                      key={i}
                      className={`node1 n${i + 1} ${
                        activeNode === i ? "active" : ""
                      }`}
                    />
                  ))}
                  <div className="scanner"></div>
                </div>

                {/* 🔥 NEW TEXT UI */}
                <div className="loader-text">
                  <div className="ai-text">🤖 {messages[textIndex]}</div>
                  <div className="ai-ids">{ids}</div>
                </div>
              </div>
            ) : (
              <>
                {gangDetails && data && memeber.length > 0 ? (
                  <>
                    <div className={`main-content ${!loader ? "show" : ""}`}>
                      <Card
                        title={
                          <div
                            style={{
                              width: "100%",
                              textAlign: "center",
                              fontWeight: "bold",
                              fontSize: 16,
                            }}
                          >
                            {t("gang_info")}
                          </div>
                        }
                        style={{
                          border: "1px solid #d9d9d9",
                          borderRadius: 6,
                          marginTop: "10px",
                        }}
                      >
                        {gangDetails && gang && (
                          <>
                            <div>
                              <Card className="viewCard profile-desc">
                                <div className="info-table">
                                  <div className="info-header">
                                    <div>घटक</div>
                                    <div>माहिती</div>
                                  </div>

                                  <div className="info-row">
                                    <div className="info-label">
                                      👥 Total Members
                                    </div>
                                    <div className="info-value">
                                      {memeber?.length} आरोपी
                                    </div>
                                  </div>

                                  <div className="info-row">
                                    <div className="info-label">
                                      📁 FIR Count
                                    </div>
                                    <div className="info-value">
                                      <b>
                                        {gangDetails?.analysis?.firs?.length}
                                      </b>{" "}
                                      एकत्रितरीत्या जोडलेले
                                    </div>
                                  </div>

                                  <div className="info-row">
                                    <div className="info-label active">
                                      🗺️ Active Years
                                    </div>
                                    <div className="info-value">
                                      <b>
                                        {gangDetails?.analysis?.years_active
                                          ?.split(",")
                                          ?.map(Number)
                                          ?.sort((a, b) => b - a)
                                          ?.join(", ")}
                                      </b>
                                    </div>
                                  </div>

                                  <div className="info-row">
                                    <div className="info-label">
                                      🎯 Key FIRs
                                    </div>
                                    <div className="info-value">
                                      {gangDetails?.analysis?.firs &&
                                        gangDetails?.analysis?.firs.length >
                                          0 &&
                                        gangDetails?.analysis?.firs.map(
                                          (fi, index) => (
                                            <>
                                              {fi}
                                              {","}
                                            </>
                                          ),
                                        )}
                                    </div>
                                  </div>
                                </div>
                              </Card>

                              <Table
                                rowKey={(record, index) => index}
                                columns={memberColumns}
                                dataSource={memeber || []}
                                bordered
                                loading={loader}
                                pagination={{ showSizeChanger: true }}
                              />
                            </div>
                          </>
                        )}

                        {/* GRAPH CARD */}
                        <div
                          style={{
                            position: "relative",
                            height: "80vh",
                            background: "#fff",
                            borderRadius: 12,
                            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              top: 20,
                              left: 20, // 👈 LEFT SIDE
                              zIndex: 10,
                            }}
                          >
                            <button
                              style={zoomBtnStyle}
                              onClick={downloadGraph}
                            >
                              ⬇
                            </button>
                          </div>
                          {/* ZOOM BUTTONS */}
                          <div
                            style={{
                              position: "absolute",
                              top: 20,
                              right: 20,
                              zIndex: 10,
                              display: "flex",
                              flexDirection: "column",
                              gap: 8,
                            }}
                          >
                            <button style={zoomBtnStyle} onClick={zoomIn}>
                              +
                            </button>
                            <button style={zoomBtnStyle} onClick={zoomOut}>
                              −
                            </button>
                            <button style={zoomBtnStyle} onClick={resetZoom}>
                              ⟳
                            </button>
                          </div>

                          {isIsolated ? (
                            <div className="p-6 text-center">
                              No connected FIR found
                            </div>
                          ) : (
                            <>
                              <div
                                style={{
                                  border: "2px solid #d9d9d9",
                                  borderRadius: "12px",
                                  height: "100%",
                                  position: "relative",
                                  background: "#fff",
                                }}
                              >
                                <div
                                  ref={cyRef}
                                  style={{ width: "100%", height: "100%" }}
                                />
                              </div>
                            </>
                          )}
                        </div>
                        <Title>Other Info</Title>
                        <Row gutter={[16, 16]} style={{ marginBottom: "10px" }}>
                          <Col xs={24} md={12}>
                            {/* ========================= CORE FIR ========================= */}
                            <Title level={4}>
                              <BulbOutlined />
                              Core FIRs (जास्त Edge)
                            </Title>

                            <Table
                              rowKey="key"
                              columns={firColumns}
                              dataSource={makeFirData(
                                gangDetails?.analysis?.core_fir,
                              )}
                              pagination={{ showSizeChanger: true }}
                              bordered
                            />
                          </Col>
                          <Col xs={24} md={12}>
                            {/* ========================= PERIPHERAL FIR ========================= */}
                            <Title level={4}>
                              <BulbOutlined /> Peripheral FIRs (कमी Edge)
                            </Title>

                            <Table
                              rowKey="key"
                              columns={firColumns}
                              dataSource={makeFirData(
                                gangDetails?.analysis?.pheripheral_fir,
                              )}
                              pagination={{ showSizeChanger: true }}
                              bordered
                            />

                            <Divider />
                          </Col>
                        </Row>
                        <Divider />
                        {/* ========================= YEAR COUNT ========================= */}
                        <Title level={4}>
                          <EnvironmentOutlined />
                          कार्यक्षेत्र (Year-wise Activity)
                        </Title>

                        <Table
                          rowKey="key"
                          columns={yearColumns}
                          dataSource={yearCountData}
                          pagination={{ showSizeChanger: true }}
                          bordered
                        />

                        <Divider />

                        {/* ========================= POLICE ACTION ========================= */}
                        <Title level={4}>
                          <SafetyOutlined /> Insights for Police Action
                        </Title>

                        <Table
                          rowKey={(record, index) => index}
                          columns={dynamicColumns}
                          dataSource={tableData}
                          pagination={{ showSizeChanger: true }}
                          bordered
                        />
                      </Card>
                    </div>
                  </>
                ) : (
                  found && (
                    <Card size="small" style={{ marginTop: "10px" }}>
                      <p style={{ textAlign: "center" }}>
                        {t("no_data_found")}
                      </p>
                    </Card>
                  )
                )}
              </>
            )}
          </PageHeader>
        </div>
      </div>
      <Modal
        title="आरोपी प्रोफाइल"
        top
        visible={viewCrimeProfile}
        onOk={closeCrimeProfile}
        onCancel={closeCrimeProfile}
        width={95 + "%"}
      >
        <ViewFormModel
          key={props && props.user.id}
          dataStates={props.professionals}
        ></ViewFormModel>
      </Modal>
      <Modal
        title={t("crime_information")}
        top
        visible={gunaView}
        onOk={closeGunaView}
        onCancel={closeGunaView}
        width={95 + "%"}
      >
        <ViewGunaDetails
          pc_crimetitles={professionals?.pc_crimetitles}
          dataStates={
            Array.isArray(professionals?.criminalViewList?.gunhaInfor) &&
            professionals?.criminalViewList?.gunhaInfor.length > 0
              ? professionals?.criminalViewList?.gunhaInfor
              : []
          }
          name={
            Array.isArray(professionals?.criminalViewList?.basicInfo) &&
            professionals?.criminalViewList?.basicInfo[0]
              ? professionals?.criminalViewList?.basicInfo[0].name
              : ""
          }
          address={
            Array.isArray(professionals?.criminalViewList?.basicInfo) &&
            professionals?.criminalViewList?.basicInfo[0]
              ? professionals?.criminalViewList?.basicInfo[0].address
              : ""
          }
          loading={gunaLoading}
          user_details={props?.user}
          masterId={
            Array.isArray(professionals?.criminalViewList?.basicInfo) &&
            professionals?.criminalViewList?.basicInfo[0]
              ? professionals?.criminalViewList?.basicInfo[0].id
              : ""
          }
          closeGunaViewModel={closeGunaView}
        ></ViewGunaDetails>
      </Modal>
    </>
  );
};

// const GraphView = (props) => {
//   const { match, dispatch, professionals } = props;
//   const { t } = useContext(LanguageContext);
//   const [loading, setLoading] = useState(false);
//   const [data, setData] = useState(null);
//   const [selectedGunha, setSelectedGunha] = useState(null);
//   const [loader, setLoader] = useState(false);
//   const [gangId, setGangId] = useState();
//   const [viewCrimeProfile, setViewCrimeProfile] = useState(false);
//   const [gunaLoading, setGunaLoading] = useState(false);
//   const [gunaView, setgunaView] = useState(false);

//   const handleSearch = async (value) => {
//     if (!value) {
//       message.error("Please enter ID");
//       return;
//     }

//     try {
//       setLoading(true);
//       let temp = {
//         id: value,
//       };

//       adminServiceAction.getCriminalDetails(temp).then((res) => {
//         setData(res);
//         setSelectedGunha(res?.gunhaInformation);
//       });
//     } catch (err) {
//       console.error(err);
//       message.error("Something went wrong");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getGangIdsFirs = () => {
//     const temp = {
//       fir: selectedGunha,
//     };
//     gangDetectionAction.getGangIdsFirs(temp).then((res) => {
//       console.log("res gang details",res)
//       const gangId = res?.data?.gangs?.[0] || null;

//       console.log("gangId:", gangId);
//       setGangId(gangId);
//     });
//   };

//   const handleCrimeProfile = (id) => {
//     setViewCrimeProfile(true);
//     dispatch(professionalAction.getCriminalsViewsById(id));
//   };

//   const closeCrimeProfile = () => {
//     setViewCrimeProfile(false);
//   };

//   const handleGunaView = (id) => {
//     setgunaView(true);
//     setGunaLoading(true);
//     dispatch(professionalAction.getCriminalsViewsById(id));
//   };
//   const closeGunaView = () => {
//     setgunaView(false);
//   };
//   useEffect(() => {
//     dispatch(professionalAction.getAllMaster());
//     props.dispatch(professionalAction.getCity());
//     props.dispatch(professionalAction.getDharm());
//     props.dispatch(professionalAction.getKalam());
//     props.dispatch(professionalAction.getKayda());
//     props.dispatch(professionalAction.getCrimeType());
//     props.dispatch(professionalAction.getCrimeTitle());
//     props.dispatch(professionalAction.getStatus());
//   }, []);

//   const memberColumns = [
//     {
//       title: t("sr.no"),
//       render: (_, __, index) => index + 1,
//       width: 80,
//     },
//     {
//       title: "CMIS ID",
//       dataIndex: "criminal_id",
//     },
//     {
//       title: t("name"),
//       dataIndex: "name",
//       render: (text, record) => (
//         <Button
//           type="link"
//           onClick={() => {
//             handleCrimeProfile(record.criminal_id);
//           }}
//         >
//           {text}
//         </Button>
//       ),
//     },
//     {
//       title: t("police_station"),
//       dataIndex: "districtname",
//     },
//     {
//       title: t("total_crimes"),
//       dataIndex: "total_crimes",
//       render: (text, record) => (
//         <Button
//           type="primary"
//           shape="circle"
//           size="small"
//           style={{
//             width: 36,
//             height: 36,
//             fontWeight: 600,
//             boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
//           }}
//           onClick={() => {
//             handleGunaView(record.criminal_id);
//           }}
//         >
//           {text}
//         </Button>
//       ),
//     },
//   ];

//   useEffect(() => {
//     // If gunaLoading is true and we have received new data, stop loading
//     if (
//       gunaLoading &&
//       props.professionals?.criminalViewList &&
//       Object.keys(props.professionals.criminalViewList).length > 0
//     ) {
//       setGunaLoading(false);
//     }
//   }, [props.professionals?.criminalViewList]);

//   const [gangDetails, setGangDetails] = useState();

//   const getGangDetails = () => {
//     setLoader(true);
//     gangDetectionAction.getGangDetails({ gang_id: gangId }).then((res) => {
//       setGangDetails(res?.data?.gang);
//     });
//     setLoader(false);
//   };
//   useEffect(() => {
//     if (selectedGunha) {
//       getGangIdsFirs();
//     }
//   }, [selectedGunha]);

//   useEffect(() => {
//     if (gangId) {
//       getGangDetails();
//     }
//   }, [gangId]);

//   useEffect(() => {
//     getGangDetails();
//   }, []);

//   return (
//     <>
//       <div className="col-md-6 col-md-offset-3">
//         <div className="site-page-header-ghost-wrapper">
//           <PageHeader
//             className="site-page-header"
//             ghost={false}
//             onBack={false}
//             title="Gang Search"
//           >
//             {/* 🔍 Search */}
//             <Search
//               placeholder="Enter Criminal ID"
//               enterButton="Search"
//               size="large"
//               onSearch={handleSearch}
//             />
//             <React.Suspense fallback={<div>Loading...</div>}>
//               {/* ⏳ Loader */}
//               {loading && (
//                 <div style={{ textAlign: "center", marginTop: 20 }}>
//                   <Spin />
//                 </div>
//               )}

//               {data && (
//                 <Card
//                   title={
//                     <span style={{ fontWeight: "bold", fontSize: 16 }}>
//                       Gang Search Details
//                     </span>
//                   }
//                   style={{
//                     border: "1px solid #d9d9d9",
//                     borderRadius: 6,
//                     marginTop: "10px",
//                   }}
//                 >
//                   {data && (
//                     <Row
//                       style={{
//                         padding: "10px 0",
//                       }}
//                     >
//                       {/* Name */}
//                       <Col span={6}>
//                         <Text strong>Name: </Text>
//                         <Text>{data.basicInfo?.[0]?.name || "N/A"}</Text>
//                       </Col>

//                       {/* Crime Count */}
//                       <Col span={6}>
//                         <Text strong>{t("total_crimes")}: </Text>
//                         <Text>{data.crimeCount || "0"}</Text>
//                       </Col>
//                       <Col span={6}>
//                         <Text strong>Fir:</Text>
//                         <Text>{selectedGunha}</Text>
//                       </Col>
//                     </Row>
//                   )}
//                 </Card>
//               )}
//             </React.Suspense>
//             {gangDetails && (
//               <>
//                 <Card
//                   title={
//                     <span style={{ fontWeight: "bold", fontSize: 16 }}>
//                       Gang Details
//                     </span>
//                   }
//                   style={{
//                     border: "1px solid #d9d9d9",
//                     borderRadius: 6,
//                     marginTop: "10px",
//                   }}
//                 >
//                   {gangDetails && (
//                     <>
//                       <Row
//                         style={{
//                           padding: "10px 0",
//                         }}
//                       >
//                         <Col span={6}>
//                           <Text strong>Gang Name: </Text>
//                           <Text>{gangDetails?.gang_name}</Text>
//                         </Col>
//                         <Col span={6}>
//                           <Text strong>Total Member: </Text>
//                           <Text>{gangDetails?.members?.length}</Text>
//                         </Col>
//                         <Col span={6}>
//                           <Text strong>FIR Count: </Text>
//                           <Text>{gangDetails?.firs?.length}</Text>
//                         </Col>
//                         <Col span={6}>
//                           <Text strong>Active Years: </Text>
//                           <Text>{gangDetails?.years_active}</Text>
//                         </Col>
//                       </Row>
//                     </>
//                   )}
//                   {gangDetails && (
//                     <>
//                       <Title level={4}>
//                         <TeamOutlined /> सदस्य संख्या (Gang Members)
//                       </Title>

//                       <Table
//                         rowKey={(record, index) => index}
//                         columns={memberColumns}
//                         dataSource={gangDetails?.members || []}
//                         bordered
//                         loading={loader}
//                         pagination={{ showSizeChanger: true }}
//                       />
//                     </>
//                   )}
//                 </Card>
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "center",
//                     marginTop: "20px",
//                   }}
//                 >
//                   <Button
//                     type="primary"
//                     className="graph-btn"
//                     icon={<BarChartOutlined />}
//                     onClick={() => {
//                       const fir = gangDetails?.fir[0];
//                       const id = gangDetails?.gang_id;
//                       if (fir) {
//                         window.open(`/graph/${id}`, "_blank");
//                       }
//                     }}
//                   >
//                     Graph
//                   </Button>
//                 </div>
//               </>
//             )}
//           </PageHeader>
//         </div>
//       </div>
//       <Modal
//         title="आरोपी प्रोफाइल"
//         top
//         visible={viewCrimeProfile}
//         onOk={closeCrimeProfile}
//         onCancel={closeCrimeProfile}
//         width={95 + "%"}
//       >
//         <ViewFormModel
//           key={props && props.user.id}
//           dataStates={props.professionals}
//         ></ViewFormModel>
//       </Modal>
//       <Modal
//         title={t("crime_information")}
//         top
//         visible={gunaView}
//         onOk={closeGunaView}
//         onCancel={closeGunaView}
//         width={95 + "%"}
//       >
//         <ViewGunaDetails
//           pc_crimetitles={professionals?.pc_crimetitles}
//           dataStates={
//             Array.isArray(professionals?.criminalViewList?.gunhaInfor) &&
//             professionals?.criminalViewList?.gunhaInfor.length > 0
//               ? professionals?.criminalViewList?.gunhaInfor
//               : []
//           }
//           name={
//             Array.isArray(professionals?.criminalViewList?.basicInfo) &&
//             professionals?.criminalViewList?.basicInfo[0]
//               ? professionals?.criminalViewList?.basicInfo[0].name
//               : ""
//           }
//           address={
//             Array.isArray(professionals?.criminalViewList?.basicInfo) &&
//             professionals?.criminalViewList?.basicInfo[0]
//               ? professionals?.criminalViewList?.basicInfo[0].address
//               : ""
//           }
//           loading={gunaLoading}
//           user_details={props?.user}
//           masterId={
//             Array.isArray(professionals?.criminalViewList?.basicInfo) &&
//             professionals?.criminalViewList?.basicInfo[0]
//               ? professionals?.criminalViewList?.basicInfo[0].id
//               : ""
//           }
//           closeGunaViewModel={closeGunaView}
//         ></ViewGunaDetails>
//       </Modal>
//     </>
//   );
// };

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;

  return {
    user,
    users,
    professionals,
  };
}

const connectedGangList = connect(mapStateToProps)(GraphView);
export { connectedGangList as GangSearch };
